import { ULabelLite } from '@uber/label-modalities/src/ulabel-lite/ulabel-lite';
import { Client as Styletron } from 'styletron-engine-monolithic';
import { Provider as StyletronProvider } from 'styletron-react';
import { LightTheme, BaseProvider, DarkTheme } from 'baseui';
import React from 'react';
export const Root = () => {
  const engine = React.useMemo(() => new Styletron(), []);
  const isLightTheme = window.matchMedia('(prefers-color-scheme: light)').matches;
  const theme = isLightTheme ? LightTheme : DarkTheme;
  const overrides = React.useMemo(() => ({
    AppContainer: {
      style: {
        height: '100%',
        backgroundColor: theme.colors.backgroundPrimary,
        color: theme.colors.primary
      }
    }
  }), [theme]);
  return <StyletronProvider value={engine}>
      <BaseProvider zIndex={100} theme={theme} overrides={overrides}>
        <ULabelLite />
      </BaseProvider>
    </StyletronProvider>;
};